import axios from 'axios';
import {eaRest, eaCsrf} from 'helpers/ea';

const Api = axios.create({
    baseURL: eaRest,
    headers: {
        'Content-Type': 'application/json',
        //'X-WP-Nonce': csrfToken
    }
});

if(eaCsrf) {
    Api.defaults.headers.common['X-WP-Nonce'] = eaCsrf.content;
}

export default Api;
